import { Collection } from 'modules/core/lib/mobx-rest'

import PolicyTimeline from 'modules/timeoff/store/models/TimeoffPolicy/PolicyTimeline'

export class PolicyTimelines extends Collection<PolicyTimeline> {
  model() {
    return PolicyTimeline
  }

  get timeline(): PolicyTimeline {
    return this.at(0)!
  }
}

const singleton: PolicyTimelines = new PolicyTimelines()

export default singleton
